var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgL2Hoptx = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 24C0 10.7452 10.7452 0 24 0C37.2548 0 48 10.7452 48 24C48 37.2548 37.2548 48 24 48C10.7452 48 0 37.2548 0 24Z",
    fill: "#E9EEFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.25 37.9486H37.75V21.0435C37.75 20.1135 37.33 19.2435 36.595 18.6735L34.75 17.2335L34.72 13.5585C34.72 12.7335 34.045 12.0735 33.22 12.0735H28.105L26.095 10.5135C25.015 9.65855 23.485 9.65855 22.405 10.5135L11.905 18.6735C11.17 19.2435 10.75 20.1135 10.75 21.0285L10.675 37.9486H9.25C8.635 37.9486 8.125 38.4585 8.125 39.0736C8.125 39.6886 8.635 40.1986 9.25 40.1986H39.25C39.865 40.1986 40.375 39.6886 40.375 39.0736C40.375 38.4585 39.865 37.9486 39.25 37.9486ZM16 25.1985V22.9485C16 22.1235 16.675 21.4485 17.5 21.4485H20.5C21.325 21.4485 22 22.1235 22 22.9485V25.1985C22 26.0235 21.325 26.6985 20.5 26.6985H17.5C16.675 26.6985 16 26.0235 16 25.1985ZM28 37.9486H20.5V33.8235C20.5 32.5785 21.505 31.5735 22.75 31.5735H25.75C26.995 31.5735 28 32.5785 28 33.8235V37.9486ZM32.5 25.1985C32.5 26.0235 31.825 26.6985 31 26.6985H28C27.175 26.6985 26.5 26.0235 26.5 25.1985V22.9485C26.5 22.1235 27.175 21.4485 28 21.4485H31C31.825 21.4485 32.5 22.1235 32.5 22.9485V25.1985Z",
    fill: "url(#paint0_linear_51_885)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_51_885",
    x1: 8.125,
    y1: 22.761,
    x2: 40.375,
    y2: 22.761,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F64E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#262FED"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgL2Hoptx, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/L2hoptx.830738fa.svg";
export { ForwardRef as ReactComponent };